import React, {createRef, ReactElement, RefObject} from 'react';
import MComponent from '../../Toolkit/Components/Component';
import {Column} from 'primereact/column';
import MTable, {MTableFilters} from '../../Toolkit/Components/Controls/Table';
import MButton from '../../Toolkit/Components/Controls/Button';
import MToolbar from '../../Toolkit/Components/Controls/Toolbar';
import {MNewIconName, MOpenIconName} from '../../Toolkit/Icons';
import FileUploadDialog from '../Dialogs/FileUploadDialog';
import MSpacer from '../../Toolkit/Components/Controls/Spacer';
import {DataTableSortMeta} from 'primereact/datatable';
import EnumContext from '../../Context/enum-context';
import { Notice } from '../../Api/NoticeTypes';
import WithRouterProps from '../../Toolkit/WithRouterProps';

type RouteParams = {}

type Props = WithRouterProps<RouteParams> & {
    safeDigId: number;
    rowData: Notice[];
}

/** */
type State = {
    filters: MTableFilters;
    selectedRow?: Notice;
}

class NoticeListControl extends MComponent<Props, State> {
    static contextType = EnumContext;
    context!: React.ContextType<typeof EnumContext>

    private readonly m_uploadRef: RefObject<FileUploadDialog>;

    public constructor(props: Props) {
        super(props);

        this.m_uploadRef = createRef<FileUploadDialog>();

        this.bindMethods();
        this.initializeState();
    }

    private bindMethods(): void {
        this.isOpenDisabled = this.isOpenDisabled.bind(this);
        this.new_Click = this.new_Click.bind(this);
        this.open_Click = this.open_Click.bind(this);
        this.table_onSelectionChange = this.table_onSelectionChange.bind(this);
        this.phaseTypeTemplate = this.phaseTypeTemplate.bind(this);
        this.permitStatusTemplate = this.permitStatusTemplate.bind(this);
    }

    private initializeState(): void {
        this.state = {
            filters: {}
        };
    }

    private table_onSelectionChange(selection: Notice | Notice[] | undefined): void {

        this.safeSetState((draft: State) =>
            draft.selectedRow = selection as Notice | undefined);

    }

    private new_Click(): void {
        this.props.navigate(`/notices/create/0/${this.props.safeDigId}/0`);
    }

    private open_Click(): void {
        this.props.navigate(`/notices/${this.state.selectedRow?.detail!.headerId}`);
    }

    private isOpenDisabled(): boolean {
        return this.state.selectedRow === undefined;
    }

    private startDateTemplate(rowData: Notice): string | undefined {
        if(rowData.detail!.startDate !== null) {
            try {
                return rowData.detail!.startDate!.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    }

    private endDateTemplate(rowData: Notice): string | undefined {
        if(rowData.detail!.endDate !== null) {
            try {
                return rowData.detail!.endDate!.toLocaleDateString();
            } catch {
                return '';
            }
        }
        return '';
    }

    private phaseTypeTemplate = (rowData:Notice) : string => {
        const index = this.context.enums?.phaseTypes.findIndex(value => value.id === rowData.detail!.phaseType);

        if(index === undefined || index === -1) {
            return '';
        }

        return this.context.enums?.phaseTypes[index!].name ?? '';
    }

    private permitStatusTemplate = (rowData:Notice) : string => {
        const index = this.context.enums?.permitStates.findIndex(value => value.id === rowData.detail!.permitStatus);

        if(index === undefined || index === -1) {
            return '';
        }

        return this.context.enums?.permitStates[index!].name ?? '';
    }

    private tableSortTemplate(): DataTableSortMeta[] {
        return [
            {field: 'odinId', order: 1}
        ];
    }

    public render(): ReactElement {
        return (
            <div>
                <MToolbar>
                    <MButton label="Add"
                             color="success"
                             icon={MNewIconName}
                             disabled={false}
                             onClick={this.new_Click}/>
                    <MSpacer/>
                    <MButton label="Open"
                             icon={MOpenIconName}
                             disabled={this.isOpenDisabled}
                             onClick={this.open_Click}/>
                </MToolbar>
                <MTable
                    rowKey="id"
                    rowData={this.props.rowData}
                    filters={this.state.filters}
                    onSelectionChange={this.table_onSelectionChange}
                    sortMode={'multiple'}
                    multiSortMeta={this.tableSortTemplate()}>

                    <Column field="odinId"
                            header="Odin ID"
                            filter={false}
                            sortable={true}
                            style={{width: '15%'}}/>
                    <Column field="startDate"
                            header="Start Date"
                            body={this.startDateTemplate}
                            dataType={'date'}
                            filter={false}
                            sortable={true}
                            style={{width: '15%'}}/>
                    <Column field="endDate"
                            header="End Date"
                            body={this.endDateTemplate}
                            dataType={'date'}
                            filter={false}
                            sortable={true}
                            style={{width: '15%'}}/>
                    <Column field="phaseType"
                            header="Phase Type"
                            body={this.phaseTypeTemplate}
                            filter={false}
                            sortable={true}
                            style={{width: '20%'}}/>
                    <Column field="permitStatus"
                            header="Permit Status"
                            body={this.permitStatusTemplate}
                            filter={false}
                            sortable={true}
                            style={{width: '35%'}}/>
                </MTable>
            </div>
        );
    }
}

export default NoticeListControl;